import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Expense, Ticket } from "../../../state/types"
import { SalaryForm } from "./salaryForm"
import { useTicketLoaders } from "../../../loaders/ticketLoaders"
import { firstItem } from "../../../../../utils/listUtils"

export const SalaryFormLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const expense = dataType as O<Expense>

    const [ready, setReady] = useState(false)
    const [ticket, setTicket] = useState<Ticket>()

    const ticketLoaders = useTicketLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        if (expense) {
            const { loadParentTickets } = ticketLoaders()
            const loadedTickets = await loadParentTickets(expense.id)
            const loadedTicket = firstItem(loadedTickets)!
            setTicket(loadedTicket)
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => {
        const expenseLabel = expense ? `: ${expense.name}` : ''
        return `${expense ? 'Editar' : 'Registrar'} Sueldo Liquidado${expenseLabel}`
    }, [expense])

    const crumbs = useGetCrumbs(
        'Sueldos Liquidados',
        RoutePath.SALARIES,
        expense?.name,
        expense?.id,
        expense ? 'Editar' : 'Registrar'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
        >
            <SalaryForm
                expense={expense}
                ticket={ticket}
            />
        </PanelLoader>
    )
}
